export default __webpack_public_path__ + "static/media/icon.a30a8836.svg";